import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export const InfoContract = (props) => {

    const {formState} = props
  return (
    <>
        <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
            Informacion sobre el credito
        </Typography>
        <div className="border-bottom border-dark"></div>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="cliente">Cliente</label>
                    <TextField
                        id='cliente'
                        name='cliente'
                        value={ formState.cliente } 
                        size='small'
                        placeholder='Cliente'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="dpi">DPI</label>
                    <TextField
                        id='dpi'
                        name='dpi'
                        value={ formState.dpi } 
                        size='small'
                        placeholder='Dpi'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="telefono">Telefono</label>
                    <TextField
                        id='telefono'
                        name='telefono'
                        value={ formState.telefono } 
                        size='small'
                        placeholder='Telefono'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="vehiculo">Vehiculo</label>
                    <TextField
                        id='vehiculo'
                        name='vehiculo'
                        value={ formState.vehiculo } 
                        size='small'
                        placeholder='Vehiculo'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="credito_dia_pago">Dia de pago</label>
                    <TextField
                        id='credito_dia_pago'
                        name='credito_dia_pago'
                        value={ formState.credito_dia_pago } 
                        size='small'
                        placeholder=''
                        type='date'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                <FormControl fullWidth>
                    <label htmlFor="total_cuota">Cuota Total (Q)</label>
                    <TextField
                        id='total_cuota'
                        name='total_cuota'
                        value={ `Q. ${formState.total_cuota}` } 
                        size='small'
                        placeholder='Q0'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true 
                        }}
                        required
                    />
                </FormControl>
            </Grid>
        </Grid>
    </>
  )
}
